import React from 'react';
import { CTASection } from '../../../components/CTASection';
export function CTA() {
  return <section className="py-16 bg-white" data-id="element-604">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-605">
        <CTASection headline="Ready to Build Your Web Application?" body="Let's discuss your web development needs and how we can deliver a solution engineered for your business." buttonText="Start the Conversation" buttonLink="/contact" variant="dark" data-id="element-606" />
      </div>
    </section>;
}